// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconShare: React.FC = () => {
    return (<svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11"><path fill="#ED1C24" d="M10.5,8.25 C10.5,9.49265599 9.49265635,10.5 8.25000036,10.5 C7.00734437,10.5 6,9.49265599 6,8.25 C6,8.15662479 6.01643479,8.06774998 6.02751625,7.97742176 L3.80845392,6.8678906 C3.40312529,7.25859404 2.85703146,7.5 2.25,7.5 C1.00734365,7.5 0,6.49265599 0,5.25 C0,4.00734401 1.00734365,3 2.25,3 C2.85609376,3 3.40382802,3.24234366 3.80859375,3.6321094 L6.02765608,2.52257824 C6.01640654,2.43281221 6,2.32265639 6,2.25 C6,1.00734329 7.00734401,0 8.25,0 C9.49265599,0 10.5,1.00734329 10.5,2.25 C10.5,3.49265671 9.49265599,4.5 8.25,4.5 C7.64390659,4.5 7.09617162,4.25765634 6.69140625,3.8678906 L4.47234392,4.97742176 C4.48359382,5.06718743 4.5,5.15625 4.5,5.25 C4.5,5.34375 4.48359382,5.43281221 4.47187507,5.52187514 L6.69093776,6.63140631 C7.09687471,6.24140596 7.64296889,6 8.25,6 C9.4921875,6 10.5,6.98671889 10.5,8.25 L10.5,8.25 Z" transform="translate(0 .25)"/></svg>);
};

export default React.memo(IconShare);
